import { Loading } from 'element-ui'

const svgPath = `
    <path style="stroke-width: 4px; fill: #409eff" d="M518.290286 311.003429c-62.902857 0-113.664-51.931429-113.664-116.443429 0-64.365714 50.761143-116.297143 113.664-116.297143S631.954286 130.194286 631.954286 194.56s-50.907429 116.443429-113.664 116.443429z m-258.633143 91.574857c-58.075429 0-104.009143-46.957714-104.009143-106.496 0-59.392 45.933714-106.496 104.009143-106.496s103.862857 47.104 103.862857 106.496c0 59.538286-45.933714 106.642286-103.862857 106.496z m-101.522286 240.201143c-50.761143 0-91.867429-42.130286-91.867428-94.061715s41.106286-94.061714 91.867428-94.061714 91.867429 42.130286 91.867429 94.061714c-2.486857 52.077714-43.593143 91.574857-91.867429 94.061715z m101.522286 235.227428c-43.446857 0-77.385143-34.669714-77.385143-79.286857s33.792-79.286857 77.385143-79.286857c43.446857 0 77.385143 34.669714 77.385143 79.286857s-33.938286 79.286857-77.385143 79.286857z m264.923428 77.970286c-36.571429 0-68.315429-31.744-68.315428-68.315429s31.744-68.315429 68.315428-68.315428 68.315429 31.744 68.315429 68.315428c0 36.717714-31.744 68.315429-68.315429 68.315429z m263.314286-97.426286c-30.573714 0-58.514286-25.453714-58.514286-58.514286 0-30.573714 25.453714-58.514286 58.514286-58.514285 30.573714 0 58.514286 25.453714 58.514286 58.514285-2.486857 33.060571-27.940571 58.514286-58.514286 58.514286z m117.028572-253.659428c-21.650286 0-39.058286-21.065143-39.058286-47.396572 0-26.331429 17.408-47.396571 39.058286-50.029714 21.650286 0 39.058286 21.065143 39.058285 47.396571 0 28.964571-17.408 50.029714-39.058285 50.029715z m-117.028572-331.337143c0 14.043429 8.338286 27.940571 19.456 33.499428 11.117714 5.558857 27.940571 8.338286 39.058286 0s19.456-19.602286 19.456-33.499428c0-22.381714-16.676571-39.204571-39.058286-39.204572-19.456 0-38.912 16.822857-38.912 39.204572z" p-id="2120"></path>
`
let loadingInstance = null

export const loadingShow = () => {
  if (!loadingInstance) {
    loadingInstance = Loading.service({
      lock: true,
      fullscreen: true,
      text: '正在努力加载页面数据,请稍等...',
      svg: svgPath,
      svgViewBox: '0 0 1024 1024',
      background: 'rgba(255,255,255, 0.5)',
    })
  }
}

export const loadingHide = () => {
  setTimeout(() => {
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
  }, 300)
}
